import React, { useState } from 'react';
import CompetionHead from '../competion-head';
import styles from './index.module.less';
import { SwitcherOutlined, TableOutlined } from '@ant-design/icons';

import { useTranslation } from 'next-i18next';
import CardList from './card-list';
import dynamic from 'next/dynamic';

const TableList = dynamic(() => import('./table-list'), {
  ssr: false,
});
const FooterStart = dynamic(() => import('../[platform]-alternatives/FooterStart'), {
  ssr: false,
});

const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});

const TwoBlogSec = dynamic(() => import('@/components/Common/TwoBlogSec'), {
  ssr: true,
});

const Index = ({ data, platList }: { data: any; platList: any }) => {
  const [isTable, setIsTable] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.head}>
        <CompetionHead type={0} />
      </div>
      <div className={styles.content}>
        <div className={styles.head}>
          <h2>{t('Top 14 OnlyFans Alternatives Platforms')}</h2>
          <div>
            <div onClick={() => setIsTable(true)} className={isTable ? styles.active : ''}>
              <SwitcherOutlined />
              <span>Table</span>
            </div>
            <div onClick={() => setIsTable(false)} className={!isTable ? styles.active : ''}>
              <TableOutlined />
              <span>Card</span>
            </div>
          </div>
        </div>

        {isTable ? <TableList platList={platList} /> : <CardList platList={platList} />}
        <div className={styles.bottomContent}>
          <TwoBlogSec
            blogList={data.data.blogList}
            topBlogList={data.data.topBlogList}
            blogTitle={data.data.contentInfo['section-blog']?.title ?? ''}
            topBlogTitle={data.data.contentInfo['section-top-blog']?.title ?? ''}
          />
          <FreQuestion data={data.data} />
        </div>
      </div>

      <FooterStart />
    </div>
  );
};

export default Index;
